import { isGoGameEnv } from 'App/constants';

import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_PREVIEW,
  COLUMN_DETAILS,
  COLUMN_STATUS,
  COLUMN_START_DATE,
  COLUMN_EXPIRATION_DATE,
  COLUMN_COMMENTS,
  COLUMN_USED_IN_ADS,
  COLUMN_TAGS,
  COLUMN_AI_TAGS,
  COLUMN_PROMO_CODE,
  COLUMN_RATING,
  COLUMN_REQUESTED_BY,
  COLUMN_DESIGNER,
  COLUMN_SHARED_WITH,
  COLUMN_USED_IN_AFFILIATES,
  COLUMN_BUSINESS_PARTNER,
  COLUMN_CREATED_BY,
  COLUMN_CREATED_DATE,
  COLUMN_UPDATED_DATE,
  COLUMN_EXCLUSIVE_FOR_AFFILIATES,
  COLUMN_TESTED,
} from 'scenes/Gallery/GalleryPage/Creatives/CreativesDataTable/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_PREVIEW,
    COLUMN_DETAILS,
    ...(isGoGameEnv ? [COLUMN_STATUS] : []),
    COLUMN_START_DATE,
    COLUMN_EXPIRATION_DATE,
    COLUMN_COMMENTS,
    ...(isGoGameEnv ? [COLUMN_TESTED] : []),
    ...(isGoGameEnv ? [COLUMN_USED_IN_ADS] : []),
    COLUMN_TAGS,
    COLUMN_AI_TAGS,
    ...(isGoGameEnv ? [COLUMN_PROMO_CODE] : []),
    COLUMN_RATING,
    ...(isGoGameEnv ? [COLUMN_EXCLUSIVE_FOR_AFFILIATES] : []),
    ...(isGoGameEnv ? [COLUMN_USED_IN_AFFILIATES] : []),
    COLUMN_REQUESTED_BY,
    COLUMN_DESIGNER,
    ...(isGoGameEnv ? [COLUMN_SHARED_WITH] : []),
    COLUMN_BUSINESS_PARTNER,
    COLUMN_CREATED_BY,
    COLUMN_CREATED_DATE,
    COLUMN_UPDATED_DATE,
  ]),
  collapsed: array(string()).default([]),
});
